module.exports = __webpack_public_path__ + "img/ctrl-ising-stub-up--i.7efe8f01.svg";